/**
 * Carga diferida del mapa de capturas.
 *
 * MapLibre pesa ~800 KB y el panel es utilizable sin mapa: las mismas
 * entrevistas están en la tabla. Cargarlo sólo cuando el supervisor abre el
 * mapa mantiene el arranque del panel en ~100 KB comprimidos.
 */

import { Suspense, lazy } from 'react';

import type { CaptureFeatureCollection } from './CaptureMap';

const CaptureMapImpl = lazy(() =>
  import('./CaptureMap').then((module) => ({ default: module.CaptureMap })),
);

export function LazyCaptureMap({ data }: { data: CaptureFeatureCollection | null }) {
  return (
    <Suspense
      fallback={
        <div
          style={{
            height: 420,
            display: 'grid',
            placeItems: 'center',
            background: 'var(--surface-alt)',
            borderRadius: 'var(--radius-lg)',
          }}
        >
          <div className="spinner" />
        </div>
      }
    >
      <CaptureMapImpl data={data} />
    </Suspense>
  );
}
